import { render, staticRenderFns } from "./recebimento-detalhe.vue?vue&type=template&id=30a19690&scoped=true"
import script from "./recebimento-detalhe.vue?vue&type=script&lang=ts"
export * from "./recebimento-detalhe.vue?vue&type=script&lang=ts"
import style0 from "./recebimento-detalhe.vue?vue&type=style&index=0&id=30a19690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a19690",
  null
  
)

export default component.exports